import { createTheme } from '@mui/material/styles';

// UEFA Champions League inspired theme
export const theme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: '#fecb00', // Gold accent
        },
        secondary: {
            main: '#0230f6', // Vibrant UEFA blue
        },
        background: {
            default: '#000139', // Even darker UEFA blue
            paper: 'rgba(255, 255, 255, 0.05)',   // More subtle, glassy surface
        },
        text: {
            primary: '#ffffff',
            secondary: '#a9b4c8',
        },
        error: {
            main: '#f44336', // Standaard rood voor fouten/negatieve waarden
        },
        success: {
            main: '#4caf50', // Standaard groen voor succes
        },
    },
    positions: { // Custom theme property for position colors
        'Keeper': { backgroundColor: 'rgba(232, 166, 12, 0.15)', color: '#E8A60C' },
        'Verdediger': { backgroundColor: 'rgba(0, 168, 225, 0.15)', color: '#00a8e1' }, // Lighter blue
        'Middenvelder': { backgroundColor: 'rgba(2, 48, 246, 0.15)', color: '#0230f6' }, // Vibrant blue
        'Aanvaller': { backgroundColor: 'rgba(236, 64, 122, 0.15)', color: '#EC407A' },
        'Coach': { backgroundColor: 'rgba(169, 180, 200, 0.15)', color: '#a9b4c8' },
    },
    typography: {
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        h4: {
            fontWeight: 700,
        },
        h6: {
            fontWeight: 700,
        },
    },
    components: {
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: 'rgba(255, 255, 255, 0.03)', // Even more subtle glass effect
                    borderBottom: '1px solid rgba(255, 255, 255, 0.15)',
                    backdropFilter: 'blur(12px)', // Frosted glass effect
                    boxShadow: 'none',
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    border: '1px solid rgba(255, 255, 255, 0.1)',
                    borderRadius: '8px',
                    backgroundColor: 'rgba(255, 255, 255, 0.05)', // More transparent
                    backdropFilter: 'blur(16px)', // Increased blur for a better glass effect
                    backgroundImage: 'none',
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    // Inherits all styles from MuiPaper
                },
            },
        },
        MuiTableContainer: {
            styleOverrides: {
                root: { backgroundColor: 'transparent' } // The container itself should be transparent
            }
        },
        MuiTableHead: {
            styleOverrides: {
                root: {
                    backgroundColor: 'rgba(255, 255, 255, 0.03)', // Even more subtle highlight
                    '& .MuiTableCell-root': {
                        fontWeight: 'bold',
                        color: '#a9b4c8',
                        borderBottom: '1px solid #0230f6',
                    },
                },
            },
        },
        MuiTableRow: {
            styleOverrides: {
                root: {
                    '&:hover': {
                        backgroundColor: 'rgba(255, 255, 255, 0.05)',
                    },
                },
            },
        },
        MuiAccordion: {
            styleOverrides: {
                root: {
                    // Inherits base styles from MuiPaper
                    boxShadow: 'none',
                    '&:before': {
                        display: 'none', // remove the top border
                    },
                    '&.Mui-expanded': {
                        margin: '16px 0',
                    }
                },
            },
        },
        MuiAccordionSummary: {
            styleOverrides: {
                root: {
                    backgroundColor: 'rgba(255, 255, 255, 0.03)', // Even more subtle highlight
                    '& .MuiAccordionSummary-content': {
                        margin: '12px 0 !important',
                    },
                },
            },
        },
        MuiTabs: {
            styleOverrides: {
                indicator: {
                    height: '3px',
                    backgroundColor: '#fecb00', // primary.main
                },
            },
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    fontWeight: '700',
                    fontSize: '1rem',
                    '&.Mui-selected': {
                        color: '#fecb00', // primary.main
                    },
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    fontWeight: '700'
                },
            },
        },
    },
});
